import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import PropTypes from "prop-types";
import React from "react";
import Typography from "@material-ui/core/Typography";
import Skeleton from "@material-ui/lab/Skeleton";
import {formatNumber} from "../../utils/formatNumber";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    border: "1px solid #D3D3D3",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.2)",
  },
  cardContainer: {
    justifyContent: "start",
    flexDirection: "row",
    flexWrap: "nowrap",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      flexDirection: "column",
    },
  },
  content: {
    padding: "36.5px 25px 27.5px 29.5px !important",
    [theme.breakpoints.down("sm")]: {
      padding: "25.5px !important",
      textAlign: "center",
    },
  },
  icon: {
    boxShadow: "none",
    color: "white",
    opacity: "1",
    padding: '20px',
    marginRight: "28px",
    overflow: 'visible',
    [theme.breakpoints.down("md")]: {
      marginRight: "28px",
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
      marginBottom: "23px",
    },
  },
  iconFloat: {
    position: "absolute",
    right: "15px",
    top: "50%",
    marginTop: "-20px",
    opacity: "0.2",
    transform: "rotate(-5deg)",
  },
  title: {
    fontSize: "1.37rem",
    fontWeight: "500",
    letterSpacing: "-0.44px",
    lineHeight: "22px",
  },
  subTitle: {
    fontSize: "1rem",
    lineHeight: "22px",
  },
  blackText: {
    color: "#212121",
  },
  grayText: {
    color: "#757575",
    fontSize: "3.75rem",
    letterSpacing: "-0.9px",
  },
  total: {
    fontSize: "2.80rem",
    color: "#757575",
    letterSpacing: "-0.9px",
  },
  cardText: {
    display: "flex",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  cardTextInner: {
    padding: "0 15px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "10px",
    },
    "&:last-child": {
      paddingRight: 0,
    },
  },
  year: {
    color: '#FF7D00', 
    fontWeight: 'bold',
  }
}));

const StatCardLarge = (props) => {
  const { type, title, value, icon, color, total, totalTitle, loading, year } = props;

  const classes = useStyles(props);
  let before = null;
  let after = null;

  const cardIcon = (
    <Grid item className={type === "fill" ? classes.iconFloat : null}>
      <IconButton
        className={classes.icon}
        aria-label={title}
        style={{ backgroundColor: "transparent", cursor: "auto" }}
      >
        {icon}
      </IconButton>
    </Grid>
  );

  if (icon) {
    type === "fill" ? (after = cardIcon) : (before = cardIcon);
  }

  return (
    <Card
      classes={{ root: classes.card }}
      style={type === "fill" ? { backgroundColor: color } : null}
    >
      <CardContent className={classes.content}>
        <Grid container alignItems={"center"} className={classes.cardContainer}>
          {before}
          <Grid item className={classes.cardText}>
            <div className={classes.cardTextInner}>
              <Typography
                variant="caption"
                className={(classes.blackText, classes.title)}
              >
                {loading ? <Skeleton width={210}/> : <div dangerouslySetInnerHTML={{ __html: `${value}<span class=${classes.year}> ${year} </span>` }} />}
              </Typography>

              <Typography variant="h3" className={classes.grayText}>
                {loading ? <Skeleton width={100}/> : `${formatNumber(title)}`}
              </Typography>
            </div>
            <div className={classes.cardTextInner}>
              <Typography
                variant="caption"
                className={(classes.blackText, classes.title)}
              >
                {loading ? <Skeleton width={210}/> : `${totalTitle}`}
              </Typography>
              <Typography
                variant="h3"
                className={(classes.grayText, classes.total)}
              >
                {loading ? <Skeleton width={100}/> : `${formatNumber(total)}`}
              </Typography>
            </div>
          </Grid>
          {after}
        </Grid>
      </CardContent>
    </Card>
  );
};

StatCardLarge.defaultProps = {
  title: 0
};

StatCardLarge.propTypes = {
  type: PropTypes.oneOf(["fill"]),
  title: PropTypes.number,
  value: PropTypes.string,
  icon: PropTypes.element,
  color: PropTypes.string,
};

export default StatCardLarge;
